import { createStyles, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) =>
  createStyles({
    "@global": {
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
      },
      html: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        height: "100%",
        width: "100%",
      },
      body: {
        backgroundColor: "#ffffff",
        height: "100%",
        width: "100%",
      },
      a: {
        textDecoration: "none",
      },
      "#root": {
        height: "100%",
        width: "100%",
      },
      ".text-capitalize": {
        textTransform: "capitalize !important",
      },
      ".text-lowercase": {
        textTransform: "lowercase !important",
      },
      ".text-uppercase": {
        textTransform: "uppercase !important",
      },
      ".text-left": {
        textAlign: "left !important",
      },
      ".text-center": {
        textAlign: "center !important",
      },
      ".text-right": {
        textAlign: "right !important",
      },
      ".text-break": {
        wordWrap: "break-word!important",
        wordBreak: "break-word!important",
      },
      ".text-wordWrap": {
        wordWrap: "break-word!important",
      },
      ".text-wordBreak": {
        wordBreak: "break-word!important",
      },
      ".text-danger": {
        color: "#dc3545 !important",
      },
      ".text-warning": {
        color: "#ffc107 !important",
      },
      ".text-success": {
        color: "#198754 !important",
      },      
      ".bg-danger": {
        backgroundColor: "#dc3545 !important",
      },
      ".bg-warning": {
        backgroundColor: "##ffc107 !important",
      },
      ".swal-button": {
        backgroundColor: "#000000",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: `#000000 !important`,
        },
      },
      ".swal-button--confirm": {
        border: `1px solid ${theme.UpdateTheme.button_color} !important`,
      },
      ".swal-button--cancel": {
        color: "#555 !important",
        "&:hover": {
          backgroundColor: `${theme.UpdateTheme.text_color} !important`,
        },
      },
      ".swal-icon--warning": {
        borderColor: `${theme.UpdateTheme.button_color} !important`,
      },
      ".swal-icon--warning__body, .swal-icon--warning__dot": {
        backgroundColor: `${theme.UpdateTheme.button_color}`,
      },
      ".theme_link": {
        color: `#333333 !important`,
      },
      ".chrome-picker .flexbox-fix div:nth-child(2) div:nth-child(2)": {
        display: " none",
      },
      ".theme_button_text": {
        color: `#ffffff !important`,
      },
      ".theme_button_bg": {
        color: `#000000 !important`,
      },
      ".theme_heading": {
        color: `#000000 !important`,
      },
      ".theme_color": {
        color: `#000000 !important`,
      },
      ".MuiPickersToolbar-toolbar, .MuiPickersDay-daySelected, .MuiPickerDTTabs-tabs, .MuiPickersClock-pin, .MuiPickersClockPointer-thumb, .MuiPickersClockPointer-pointer, .MuiPickersClockNumber-clockNumberSelected":
        {
          backgroundColor: `#000000 !important`,
        },
      ".theme_table_head_bg": {
        backgroundColor: `#000000 !important`,
        color: `#ffffff !important`,
        "& th": {
          color: `#ffffff !important`,
        },
      },
      ".text-white": {
        color: "#fff !important",
      },
      ".float-left": {
        float: "left !important",
      },
      ".float-right": {
        float: "right !important",
      },
      ".pl-15": {
        paddingLeft: "15px !important",
      },
      ".h-100": {
        height: "100% !important",
      },
      ".w-100": {
        width: "100% !important",
      },
      ".editor-tagstyles ol": {
        margin: " 10px 0px 10px 20px !important",
      },
      ".editor-tagstyles ul": {
        margin: " 10px 0px 10px 20px !important",
      },
      ".page-wrap": {
        padding: "0px 20px",
      },
      ".page-head": {
        color: `#333 !important`,
        marginBottom: "10px !important",
        fontSize: "22px !important",
      },
      ".page-sub-head": {
        color: `#fff !important`,
        marginBottom: "10px !important",
        fontSize: "20px !important",
        fontWeight: "500",
      },
      ".MuiListItem-root.Mui-selected": {
        //".MuiListItem-root.Mui-selected:hover":
        backgroundColor: `#000 !important`,
        color: `#fff !important`,
        "&:hover": {
          backgroundColor: `#000 !important`,
        },
      },
      ".disable-btn": {
        color: "#8c8c8c !important",
      },
      ".white-btn": {
        backgroundColor: "#ffffff",
      },
      ".editor-tagstyles": {
        "& ol": {
          margin: " 10px 0px 10px 20px !important",
        },
        "& ul": {
          margin: " 10px 0px 10px 20px !important",
        },
      },
      ".rbc-current-time-indicator": {
        //backgroundColor: `${theme.UpdateTheme.button_color} !important`,
        height: "2px !important",
      },
      ".ck-content .image>figcaption": {
        display: "none !important",
      },

      ".ck-powered-by__label": {
        display: "none",
      },
      ".ck.ck-powered-by": {
        display: "none",
      },
      ".mb-10": {
        marginBottom: "10px",
      },
      ".ck-imagesize img": {
        maxWidth: "225px",
        maxHeight: "150px",
        width: "100%",
        height: "auto",
        objectFit: "contain",
        objectPosition: "left",
        marginTop: "10px",
      },
      ".no-scroll": {
        overflow: "hidden !important",
      },
      ".max-w": {
        maxWidth: "130px !important",
        // color: `${theme.UpdateTheme.heading_color} !important`,
      },
      ".c-pointer": {
        cursor: "pointer !important",
      },
      ".swal-title": {
        textTransform: "none",
      },
      ".discussion_img": {
        "& img": {
          display: "none",
        },
      },
      ".MuiButton-root": {
        textTransform: "capitalize",
      },
      ".socialWall .btn": {
        backgroundColor: "#000",
        color: "#fff",
        borderRadius: "25px",
      },
      ".notallowed": {
        cursor: "not-allowed !important",
      },
      ".ag-cell-focus": {
        borderColor: "transparent !important",
      },
      ".ag-header-cell-text": {
        color: "#fff",
      },
      ".ag-icon": {
        color: "#fff",
      },
      ".img-responsive": {
        maxWidth: "100%",
        height: "auto",
      },
      ".bg-published": {
        backgroundColor: "#e2f1e2",
      },
      ".bg-draft": {
        backgroundColor: "#efefef",
      },
      ".text-approve": {
        color: "green !important",
      },
      ".text-reject": {
        color: "red !important",
      },
      ".text-limit": {
        color: "#000",
        fontSize: "12px",
      },
      ".back-btn": {
        cursor: "pointer",
        color: "fff",
        marginBottom: "5px",
      },
      ".back-btn .back-btn-text": {
        fontSize: "12px",
      },
      ".all-center": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      },
      ".active_dark": {
        color: "#fff",
      }
    },
  })
);

const GlobalStylesDarkTheme = () => {
  useStyles();
  return null;
};

export default GlobalStylesDarkTheme;
